import OurVue from "vue";
import { consoleError } from "./util/console";

export function install(Vue, args = {}) {
  if (install.installed) return;
  install.installed = true;

  if (OurVue !== Vue) {
    consoleError("Multiple instances of Vue detected");
  }

  const components = args.components || {};
  const directives = args.directives || {};
  const filters = args.filters || {};

  for (const name in directives) {
    const directive = directives[name];
    Vue.directive(name, directive);
  }

  for (const name in filters) {
    const filter = filters[name];
    Vue.filter(name, filter);
  }

  (function registerComponents(components) {
    if (components) {
      for (const key in components) {
        const component = components[key];
        if (component && !registerComponents(component.$_subcomponents)) {
          Vue.component(key, component);
        }
      }
      return true;
    }
    return false;
  })(components);

  if (Vue.$_core_installed) return;
  Vue.$_core_installed = true;

  Vue.mixin({
    beforeCreate() {
      const options = this.$options;

      if (options.core) {
        options.core.init(this, Vue);
        this.$core = Vue.observable(options.core.framework);
      } else {
        this.$core = (options.parent && options.parent.$core) || this;
      }
    }
  });
}
